import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController'
import { FragmentNames, ModalPaymentIframeAliases } from '../../codegen';
import { Value } from '@philips-internal/oswald-ui-core';

@Controller({ fragment: FragmentNames.MODAL_PAYMENT_IFRAME })
class ModalPaymentIframeController extends BaseController {

  @OnMount({ target: ModalPaymentIframeAliases.I_FRAME_PAYMENT })
  onMount(): void {
    const data = this.context.get('data') as Record<string, Value>;
    console.log(data);
  }

}

export default ModalPaymentIframeController;
